/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathXDivideY2 = createReactComponent("math-x-divide-y-2", "IconMathXDivideY2", [
  ["path", { d: "M3 21l18 -18", key: "svg-0" }],
  ["path", { d: "M15 14l3 4.5", key: "svg-1" }],
  ["path", { d: "M21 14l-4.5 7", key: "svg-2" }],
  ["path", { d: "M3 4l6 6", key: "svg-3" }],
  ["path", { d: "M3 10l6 -6", key: "svg-4" }]
]);

export { IconMathXDivideY2 as default };
//# sourceMappingURL=IconMathXDivideY2.js.map
